<template>
  <div>
    <Loader v-if="loading"></Loader>
    <div class="wrraper" v-else>
      <!-- Start Breadcrumb -->
      <Breadcrumb
        :items="items"
        :show_print="true"
        :excelFile="true"
        :excelData="excelData"
      />
      <!-- End Breadcrumb -->
      <!-- start of searchSection  -->
      <SearchSection
        @filterTable="searchTable"
        title="تحويل عملة لعميل"
        :type="transferType"
      ></SearchSection>
      <!-- end of searchSection  -->
      <!-- notFound  -->
      <Notfound v-if="!searchItems"></Notfound>
      <!-- Start Statistics Card-->
      <div v-else>
        <!-- Start Statistics Card-->
        <ul class="all-state-count">
          <li>
            <div class="state-count">
              <span>عدد عمليات تحويل العملة :</span>
              <span>{{ table_length }}</span>
            </div>
          </li>
        </ul>
        <!-- End Statistics Card-->

        <!-- Start Main Section -->
        <ul class="table-tabs">
          <li>
            <button
              type="button"
              :class="{ active: transferType == 'customer' }"
              @click="tabClick('customer')"
            >
              تحويلات العملاء
            </button>
          </li>
          <li>
            <button
              type="button"
              :class="{ active: transferType == 'enterprise' }"
              @click="tabClick('enterprise')"
            >
              تحويلات المؤسسات
            </button>
          </li>
        </ul>
        <main class="main-table table-print">
          <!-- start of  header of printSection  -->
          <PrintHead
            :title="
              transferType == 'customer'
                ? 'تحويلات العملاء'
                : 'تحويلاات المؤسسات'
            "
            :number="table_length"
          ></PrintHead>
          <!-- end of header of printSection  -->
          <v-data-table
            class="thumb"
            :headers="headers"
            :items="rows"
            :search="search"
            :loading="lodaing"
            :loading-text="$t('table.loadingData')"
            v-model="selected"
            :single-select="singleSelect"
            :items-per-page="rows.length"
            item-key="id"
            hide-default-footer
          >
            <!-- ================== You Can use any slots you want ================== -->
            <!-- ====== Select row field ====== -->
            <!-- title -->
            <template v-slot:[`item.desc`]="{ item }">
              <v-icon
                class="show"
                small
                @click="
                  modal.descriptionModalIsOpen = true;
                  setItemDesc(item.desc);
                "
              >
                fal fa-eye
              </v-icon>
            </template>
            <template v-slot:[`item.index`]="{ index }">
              {{ index + 1 }}
            </template>
            <!-- Select no data State -->
            <template v-slot:no-data>
              {{ $t("table.noData") }}
            </template>
            <!-- revision status-->
            <template v-slot:[`item.review_status`]="{ item }">
              <v-chip color="#d7c100" v-if="item.review_status == 0">
                منتظر
              </v-chip>
              <v-chip color="green" v-else> تأكيد </v-chip>
            </template>
            <!-- Confirm revision-->
            <template v-slot:[`item.revision_done`]="{ item }">
              <!--  -->
              <div class="_actions actions2">
                <button
                  type="button"
                  class="accept confirm_btn ml-0"
                  @click="revisionDone(item)"
                  v-if="item.review_status == 0"
                >
                  <i class="far fa-check"></i>
                </button>
                <span v-else> ---- </span>
              </div>
            </template>
            <template v-slot:[`item.amount`]="{ item }">
              {{ Number(item.amount).toLocaleString() }}
            </template>
            <template v-slot:[`item.total`]="{ item }">
              {{ Number(item.total).toLocaleString() }}
            </template>
            <!-- Select actions-->
            <template v-slot:[`item.actions`]="{ item }">
              <div class="_actions">
                <!-- <v-icon class="show" small @click="showItem(item)">
              fal fa-eye
            </v-icon> -->
                <!-- <v-icon class="edit" small @click="editItem(item)">
                  fal fa-edit
                </v-icon> -->
                <v-icon class="delete" small @click="deleteItem(item)">
                  fal fa-trash
                </v-icon>
              </div>
            </template>

            <!-- ======================== Start Top Section ======================== -->
            <template v-slot:top>
              <!-- Delete dialog -->
              <v-dialog v-model="dialogDelete" max-width="500px">
                <v-card>
                  <v-card-title class="text-h6 justify-center">{{
                    $t("table.deletedialog.areYouSure")
                  }}</v-card-title>
                  <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="#1B5E20" @click="deleteItemConfirm"
                      >{{ $t("table.deletedialog.ok") }}
                      <span
                        class="btn_loader_model"
                        v-if="loadingBtnDialog"
                      ></span
                    ></v-btn>
                    <v-btn color="#F44336" @click="dialogDelete = false">{{
                      $t("table.deletedialog.cancel")
                    }}</v-btn>
                    <v-spacer></v-spacer>
                  </v-card-actions>
                </v-card>
              </v-dialog>
              <!-- confirm dialog -->
              <v-dialog v-model="dialogConfirm" max-width="500px">
                <v-card>
                  <v-card-title class="text-h5 justify-center">
                    هل تمت المراجعه علي العملية ؟
                  </v-card-title>
                  <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="#1B5E20" @click="revisionConfirm"
                      >{{ $t("table.deletedialog.ok") }}
                      <span
                        class="btn_loader_model"
                        v-if="loadingBtnDialog"
                      ></span
                    ></v-btn>
                    <v-btn color="#F44336" @click="dialogConfirm = false">{{
                      $t("table.deletedialog.cancel")
                    }}</v-btn>
                    <v-spacer></v-spacer>
                  </v-card-actions>
                </v-card>
              </v-dialog>
              <v-dialog v-model="dialogShow" min-width="50%">
                <v-card class="p-0">
                  <div class="show_modal_content_wrapper" v-if="itemToShow">
                    <div class="row">
                      <div class="col-md-6">
                        <div class="data_line_wrapper">
                          <h5 class="mb-3">وصف</h5>
                          <h6>{{ itemToShow.desc }}</h6>
                        </div>
                      </div>
                    </div>
                  </div>
                </v-card>
              </v-dialog>

              <!-- Description Modal -->
              <DescModal
                :desc="selectedItemDesc"
                :handelModalApperance="modal.descriptionModalIsOpen"
                @close="closeDescModal"
              />

              <!-- Row -->
            </template>
            <!-- ======================== End Top Section ======================== -->
          </v-data-table>
        </main>
        <!-- End Main Section -->
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import StatsCard from "@/components/Charts/ChartComponent.vue";
import DescModal from "@/components/modals/DescriptionModal.vue";
import SearchSection from "@/components/Search/currencyTransfare";
export default {
  name: "ShowAllTransfersCurrencies",

  components: {
    StatsCard,
    DescModal,
    SearchSection,
  },

  data() {
    return {
      // loadingBtnDialog
      loadingBtnDialog: false,
      // search
      searchItems: null,
      // loader
      loading: true,
      // ========== Breadcrumbs
      items: [
        {
          text: this.$t("breadcrumb.mainPage"),
          disabled: false,
          href: "/",
        },
        {
          text: this.$t("breadcrumb.currency.transfer"),
          disabled: true,
          href: "",
        },
      ],

      // ========== Statistics
      statisticsItems: [
        {
          id: 1,
          icon: "fal fa-images",
          title: "all",
          number: "10",
        },
      ],

      // ========== Top Section
      search: "",

      // ========== dialog Status
      dialogShow: false,
      itemToShow: null,
      dialogDelete: false,
      dialogDelete_selected: false,
      itemtoDelete: null,
      dialogConfirm: false,
      itemtoConfirm: null,
      // ========== Your Data
      rows: [], // injected in created

      // ========== elected Data
      selected: [],
      singleSelect: false,

      // Custom Modal Data
      modal: {
        descriptionModalIsOpen: false,
      },
      selectedItemDesc: null,

      // ========== Loding
      lodaing: false,
      table_length: null,
      transferType: "customer",
      // excel data
      excelData: {
        name: null,
        items: null,
        json_fields: {
          الحساب: "balance_customer",
          "الحساب المحول إليه": "transferred_balance_customer",
          المبلغ: {
            field: "amount",
            callback: (value) => {
              return Number(value).toLocaleString();
            },
          },
          ضرب: "multiply",
          قسمة: "dividing",
          الإجمالي: {
            field: "total",
            callback: (value) => {
              return Number(value).toLocaleString();
            },
          },
          الخزنة: "wallet.name",
          التاريخ: "created_at",
        },
      },
    };
  },

  computed: {
    ...mapGetters({
      lang: "lang_module/lang",
    }),

    headers() {
      var userType = JSON.parse(this.$store.state.usertype) || null;
      if (
        userType.includes("superadmin") ||
        (userType.includes("lock_and_deals") &&
          userType.includes("confirm_lock_and_deals"))
      ) {
        if (this.lang == "ar" && this.transferType == "customer") {
          return [
            {
              text: "#",
              value: "index",
              sortable: false,
              align: "center",
              width: 10,
            },
            {
              text: "اسم العميل",
              value: "balance_customer",
              align: "center",
              width: 200,
            },

            {
              text: "اسم العميل المحول إليه",
              value: "transferred_balance_customer",
              align: "center",
              width: 200,
            },
            {
              text: "المبلغ",
              value: "amount",
              align: "center",
              sortable: false,
              width: 100,
            },
            {
              text: "ضرب",
              value: "multiply",
              align: "center",
              sortable: false,
              width: 50,
            },
            {
              text: "قسمة",
              value: "dividing",
              align: "center",
              sortable: false,
              width: 50,
            },
            {
              text: "الإجمالي",
              value: "total",
              align: "center",
              sortable: false,
              width: 100,
            },
            {
              text: "الخزنة",
              value: "wallet.name",
              align: "center",
              width: 100,
            },
            {
              text: "التاريخ",
              value: "created_at",
              align: "center",
              width: 100,
            },
            {
              text: "المراجعة",
              value: "review_status",
              align: "center",
              sortable: false,
              class: "showOnPrint",
              cellClass: "showOnPrint",
              width: 50,
            },
            {
              text: "تأكيد",
              value: "revision_done",
              align: "center",
              sortable: false,
              class: "showOnPrint",
              cellClass: "showOnPrint",
              width: 50,
            },
            {
              text: "التحكم",
              value: "actions",
              sortable: false,
              align: "center",
              class: "showOnPrint",
              cellClass: "showOnPrint",
              width: 50,
            },
          ];
        }
        if (this.lang == "ar" && this.transferType == "enterprise") {
          return [
            {
              text: "حساب المؤسسة",
              value: "balance_customer",
              align: "center",
              width: 200,
            },
            {
              text: " حساب المؤسسة المحول إليه",
              value: "transferred_balance_customer",
              align: "center",
              width: 250,
            },
            {
              text: "المبلغ",
              value: "amount",
              align: "center",
              sortable: false,
              width: 100,
            },
            {
              text: "ضرب",
              value: "multiply",
              align: "center",
              sortable: false,
              width: 50,
            },
            {
              text: "قسمة",
              value: "dividing",
              align: "center",
              sortable: false,
              width: 50,
            },
            {
              text: "الإجمالي",
              value: "total",
              align: "center",
              sortable: false,
              width: 100,
            },
            {
              text: "الخزنة",
              value: "wallet.name",
              align: "center",
              width: 100,
            },
            {
              text: "التاريخ",
              value: "created_at",
              align: "center",
              width: 100,
            },
            {
              text: "المراجعة",
              value: "review_status",
              align: "center",
              sortable: false,
              class: "showOnPrint",
              cellClass: "showOnPrint",
              width: 50,
            },
            {
              text: "تأكيد",
              value: "revision_done",
              align: "center",
              sortable: false,
              class: "showOnPrint",
              cellClass: "showOnPrint",
              width: 50,
            },
            {
              text: "التحكم",
              value: "actions",
              sortable: false,
              align: "center",
              class: "showOnPrint",
              cellClass: "showOnPrint",
              width: 50,
            },
          ];
        }
      } else if (!userType.includes("confirm_lock_and_deals")) {
        if (this.lang == "ar" && this.transferType == "customer") {
          return [
            {
              text: "#",
              value: "index",
              sortable: false,
              align: "center",
              width: 10,
            },
            {
              text: "اسم العميل",
              value: "balance_customer",
              align: "center",
              width: 200,
            },

            {
              text: "اسم العميل المحول إليه",
              value: "transferred_balance_customer",
              align: "center",
              width: 200,
            },
            {
              text: "المبلغ",
              value: "amount",
              align: "center",
              sortable: false,
              width: 100,
            },
            {
              text: "ضرب",
              value: "multiply",
              align: "center",
              sortable: false,
              width: 50,
            },
            {
              text: "قسمة",
              value: "dividing",
              align: "center",
              sortable: false,
              width: 50,
            },
            {
              text: "الإجمالي",
              value: "total",
              align: "center",
              sortable: false,
              width: 100,
            },
            {
              text: "الخزنة",
              value: "wallet.name",
              align: "center",
              width: 100,
            },
            {
              text: "التاريخ",
              value: "created_at",
              align: "center",
              width: 100,
            },
            {
              text: "المراجعة",
              value: "review_status",
              align: "center",
              sortable: false,
              class: "showOnPrint",
              cellClass: "showOnPrint",
              width: 50,
            },
            {
              text: "التحكم",
              value: "actions",
              sortable: false,
              align: "center",
              class: "showOnPrint",
              cellClass: "showOnPrint",
              width: 50,
            },
          ];
        }
        if (this.lang == "ar" && this.transferType == "enterprise") {
          return [
            {
              text: "حساب المؤسسة",
              value: "balance_customer",
              align: "center",
              width: 200,
            },
            {
              text: " حساب المؤسسة المحول إليه",
              value: "transferred_balance_customer",
              align: "center",
              width: 250,
            },
            {
              text: "المبلغ",
              value: "amount",
              align: "center",
              sortable: false,
              width: 100,
            },
            {
              text: "ضرب",
              value: "multiply",
              align: "center",
              sortable: false,
              width: 50,
            },
            {
              text: "قسمة",
              value: "dividing",
              align: "center",
              sortable: false,
              width: 50,
            },
            {
              text: "الإجمالي",
              value: "total",
              align: "center",
              sortable: false,
              width: 100,
            },
            {
              text: "الخزنة",
              value: "wallet.name",
              align: "center",
              width: 100,
            },
            {
              text: "التاريخ",
              value: "created_at",
              align: "center",
              width: 100,
            },
            {
              text: "المراجعة",
              value: "review_status",
              align: "center",
              sortable: false,
              class: "showOnPrint",
              cellClass: "showOnPrint",
              width: 50,
            },
            {
              text: "التحكم",
              value: "actions",
              sortable: false,
              align: "center",
              class: "showOnPrint",
              cellClass: "showOnPrint",
              width: 50,
            },
          ];
        }
      } else {
        if (this.lang == "ar" && this.transferType == "customer") {
          return [
            {
              text: "#",
              value: "index",
              sortable: false,
              align: "center",
              width: 10,
            },
            {
              text: "اسم العميل",
              value: "balance_customer",
              align: "center",
              width: 200,
            },

            {
              text: "اسم العميل المحول إليه",
              value: "transferred_balance_customer",
              align: "center",
              width: 200,
            },
            {
              text: "المبلغ",
              value: "amount",
              align: "center",
              sortable: false,
              width: 100,
            },
            {
              text: "ضرب",
              value: "multiply",
              align: "center",
              sortable: false,
              width: 50,
            },
            {
              text: "قسمة",
              value: "dividing",
              align: "center",
              sortable: false,
              width: 50,
            },
            {
              text: "الإجمالي",
              value: "total",
              align: "center",
              sortable: false,
              width: 100,
            },
            {
              text: "الخزنة",
              value: "wallet.name",
              align: "center",
              width: 100,
            },
            {
              text: "التاريخ",
              value: "created_at",
              align: "center",
              width: 100,
            },
            {
              text: "المراجعة",
              value: "review_status",
              align: "center",
              sortable: false,
              class: "showOnPrint",
              cellClass: "showOnPrint",
              width: 50,
            },
            {
              text: "تأكيد",
              value: "revision_done",
              align: "center",
              sortable: false,
              class: "showOnPrint",
              cellClass: "showOnPrint",
              width: 50,
            },
          ];
        }
        if (this.lang == "ar" && this.transferType == "enterprise") {
          return [
            {
              text: "حساب المؤسسة",
              value: "balance_customer",
              align: "center",
              width: 200,
            },
            {
              text: " حساب المؤسسة المحول إليه",
              value: "transferred_balance_customer",
              align: "center",
              width: 250,
            },
            {
              text: "المبلغ",
              value: "amount",
              align: "center",
              sortable: false,
              width: 100,
            },
            {
              text: "ضرب",
              value: "multiply",
              align: "center",
              sortable: false,
              width: 50,
            },
            {
              text: "قسمة",
              value: "dividing",
              align: "center",
              sortable: false,
              width: 50,
            },
            {
              text: "الإجمالي",
              value: "total",
              align: "center",
              sortable: false,
              width: 100,
            },
            {
              text: "الخزنة",
              value: "wallet.name",
              align: "center",
              width: 100,
            },
            {
              text: "التاريخ",
              value: "created_at",
              align: "center",
              width: 100,
            },
            {
              text: "المراجعة",
              value: "review_status",
              align: "center",
              sortable: false,
              class: "showOnPrint",
              cellClass: "showOnPrint",
              width: 50,
            },
            {
              text: "تأكيد",
              value: "revision_done",
              align: "center",
              sortable: false,
              class: "showOnPrint",
              cellClass: "showOnPrint",
              width: 50,
            },
          ];
        }
      }
    },
  },

  methods: {
    // searchTable
    searchTable(items) {
      this.rows = [];
      this.searchItems = items;
      this.setRows();
    },
    // ==================== Start CRUD ====================
    addItem() {
      this.$router.push({ path: "/currency/transfer-currency" });
    },
    showItem(item) {
      this.dialogShow = true;
      this.itemToShow = item;
    },
    editItem(item) {
      this.$router.push({
        path: "/currency/edit-transfer-currency/" + item.id,
      });
    },
    // confirm item
    revisionDone(item) {
      this.dialogConfirm = true;
      this.itemtoConfirm = item;
    },
    revisionConfirm() {
      this.loadingBtnDialog = true;
      this.$axios({
        method: "POST",
        url: `client/currency_transformation/review/${this.itemtoConfirm.id}`,
      })
        .then(() => {
          this.loadingBtnDialog = false;
          this.setRows();
          this.dialogConfirm = false;
          this.$iziToast.success({
            timeout: 2000,
            message: "تم التأكيد بنجاح",
            position: "topRight",
          });
        })
        .catch((err) => {
          this.dialogConfirm = false;
          this.$iziToast.error({
            timeout: 2000,
            message: err.response.data.message,
            position: "topRight",
          });
        });
    },
    // ===== Delete
    deleteItem(item) {
      this.dialogDelete = true;
      this.itemtoDelete = item;
    },
    deleteItemConfirm() {
      this.loadingBtnDialog = true;
      this.$axios({
        method: "DELETE",
        url: `client/currency_transformation/${this.itemtoDelete.id}`,
      })
        .then(() => {
          this.loadingBtnDialog = false;
          this.setRows();
          this.dialogDelete = false;
          this.$iziToast.success({
            timeout: 2000,
            message: this.$t("CRUD.Delete"),
            position: "topRight",
          });
          this.$store.dispatch("getTranshState");
        })
        .catch((err) => {
          this.dialogDelete = false;
          this.$iziToast.error({
            timeout: 2000,
            message: err.response.data.message,
            position: "topRight",
          });
        });
    },
    setItemDesc(desc) {
      this.selectedItemDesc = desc;
    },
    closeDescModal() {
      this.modal.descriptionModalIsOpen = false;
    },
    // ==================== End CRUD ====================

    // ================ Set Rows
    tabClick(type) {
      this.rows = [];
      this.transferType = type;
      this.setRows();
    },
    setRows() {
      if (this.transferType == "customer") {
        this.lodaing = true;
        this.$axios({
          method: "GET",
          url: "client/currency_transformation?type=customer",
          params: {
            wallet_id: this.searchItems ? this.searchItems.lockId : null,
            customer: this.searchItems ? this.searchItems.username : null,
            from_date: this.searchItems ? this.searchItems.from : null,
            to_date: this.searchItems ? this.searchItems.to : null,
          },
        })
          .then((res) => {
            this.rows = res.data.data;
            this.table_length = this.rows.length;
            this.excelData.items = this.rows;
            this.excelData.name = "تحويلات العملاء";
            this.rows.forEach((ele) => {
              if (this.transferType == "customer") {
                ele["balance_customer"] = ele.balance_customer.name;
                ele["transferred_balance_customer"] =
                  ele.transferred_balance_customer.name;
              } else {
                ele["balance_customer"] = ele.account.name;
                ele["transferred_balance_customer"] =
                  ele.transferred_account.name;
              }
            });
            this.lodaing = false;
          })
          .catch((err) => {
            this.lodaing = false;
          });
      }
      if (this.transferType == "enterprise") {
        this.lodaing = true;
        this.$axios({
          method: "GET",
          url: "client/currency_transformation?type=enterprise",
          params: {
            wallet_id: this.searchItems ? this.searchItems.lockId : null,
            account_id: this.searchItems
              ? this.searchItems.enterpriceAccount
              : null,
            from_date: this.searchItems ? this.searchItems.from : null,
            to_date: this.searchItems ? this.searchItems.to : null,
          },
        })
          .then((res) => {
            this.rows = res.data.data;
            this.table_length = this.rows.length;
            this.excelData.items = this.rows;
            this.excelData.name = "تحويلات المؤسسات";
            this.rows.forEach((ele) => {
              if (this.transferType == "customer") {
                ele["balance_customer"] = ele.balance_customer.name;
                ele["transferred_balance_customer"] =
                  ele.transferred_balance_customer.name;
              } else {
                ele["balance_customer"] = ele.account.name;
                ele["transferred_balance_customer"] =
                  ele.transferred_account.name;
              }
            });
            this.lodaing = false;
          })
          .catch((err) => {
            this.lodaing = false;
          });
      }
    },
  },

  // ======= hooks
  created() {
    setTimeout(() => {
      this.loading = false;
    }, 1000);
    // permisions
    var userType = JSON.parse(this.$store.state.usertype) || null;
    if (
      !userType.includes("superadmin") &&
      !userType.includes("lock_and_deals") &&
      !userType.includes("confirm_lock_and_deals")
    ) {
      this.$router.push("/");
    }
  },
};
</script>
